// The "Your Submitted Surveys" time filter.
//
// Everything is fetched once and narrowed here: one person's own submissions is
// a small list, so switching windows shouldn't cost a round trip.

// `days: null` means no cutoff at all.
export const RANGE_OPTIONS = [
  { id: '7', label: '7 days', days: 7 },
  { id: '30', label: '30 days', days: 30 },
  { id: '90', label: '90 days', days: 90 },
  { id: 'all', label: 'All time', days: null },
];

export const DEFAULT_RANGE_ID = '7';

export const findRange = (id) => RANGE_OPTIONS.find((r) => r.id === id) || RANGE_OPTIONS[0];

export const filterByRange = (submissions = [], days, now = Date.now()) => {
  if (days == null) return submissions;
  const cutoff = now - days * 24 * 60 * 60 * 1000;
  return submissions.filter((s) => {
    const at = new Date(s?.submitted_at).getTime();
    // An unreadable timestamp can't be placed in the window, so it stays out
    // rather than sorting to 1970 and appearing under every preset.
    return Number.isNaN(at) ? false : at >= cutoff;
  });
};
